export default class EditSchoolCommonRoomController {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast, moment,
    SchoolCommonRoomService,
    UtilService,
    schoolCommonRoom
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.moment = moment;
    this.SchoolCommonRoomService = SchoolCommonRoomService;
    this.UtilService = UtilService;
    this.schoolCommonRoom = schoolCommonRoom;

    if (this.schoolCommonRoom.workingHourStart) {
      this.startTime = this.moment(this.UtilService.parseTime(this.schoolCommonRoom.workingHourStart)).format('HH:mm');
    }

    if (this.schoolCommonRoom.workingHourEnd) {
      this.endTime = this.moment(this.UtilService.parseTime(this.schoolCommonRoom.workingHourEnd)).format('HH:mm');
    }
  }

  cancel() {
    this.$mdDialog.cancel();
  }

  update(form) {
    if (form.$invalid) {
      return false;
    }

    this.schoolCommonRoom.workingHourStart = this.startTime;
    this.schoolCommonRoom.workingHourEnd = this.endTime;
    this.SchoolCommonRoomService.edit(this.schoolCommonRoom)
      .then(result => {
        this.$mdDialog.hide(result);
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Pomyślnie edytowano świetlicę')
            .position('bottom right')
            .hideDelay(3000)
        );
      }).catch(error => {
        this.$mdDialog.show(
          this.$mdDialog.extendError({
            locals: {error}
          })
        );
      });
  }
}
